<style>
  .promo-panel {
    flex: 3;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 24px;
    min-width: 0;
  }

  .promo-caption {
    width: min(100%, 450px);
    text-align: left;
    transition: opacity 600ms ease;
  }

  .promo-caption h2 {
    margin: 0 0 8px;
    font-size: 1.35rem;
    font-weight: 600;
  }

  .promo-caption p {
    margin: 0;
    font-size: 0.95rem;
    line-height: 1.45;
    color: #555;
  }

  .promo-stage {
    position: relative;
    width: min(100%, 450px);
    aspect-ratio: 4 / 3;
  }

  .promo-card {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: contain;
    transition:
      transform 600ms ease,
      opacity 600ms ease,
      filter 600ms ease;
  }

  .promo-card--front {
    z-index: 2;
    opacity: 1;
    filter: blur(0);
    transform: translate(0, 0) scale(1);
  }

  .promo-card--back {
    z-index: 1;
    opacity: 0.55;
    filter: blur(2px);
    transform: translate(30px, 18px) scale(0.96);
  }

  .sign-in-layout {
    display: flex;
    justify-content: center;
    align-items: stretch;
    max-width: 1200px;
    margin: 0 auto;
    gap: 60px;
    padding: 24px 32px;
    box-sizing: border-box;
    width: 100%;
  }

  .form-panel {
    flex: 2;
    min-width: 320px;
    max-width: 420px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: stretch;
  }

  .form-panel-inner {
    width: 100%;
  }

  @media (max-width: 900px) {
    .sign-in-layout {
      flex-direction: column;
      gap: 40px;
      padding: 24px 20px;
    }

    .form-panel {
      flex: none;
      width: 100%;
      max-width: 420px;
      margin: 0 auto;
    }

    .promo-panel {
      flex: none;
      width: 100%;
    }
  }
</style>

<div class="sign-in-layout">

    <div class="form-panel">
        <div class="form-panel-inner">

        <div [hidden]="pageMode != 'signIn'">
            <h1 style="margin-bottom:20px;">Sign In</h1>

            <div class="form-group" style="width:100%;">
                <app-textbox [label]="'Email Address'" [width]="'100%'" id="username" name="username" [(ngModel)]="email" />
            </div>
            <div class="form-group">
                <app-textbox [label]="'Password'" [width]="'100%'" [type]="'Password'" id="password" name="password" [(ngModel)]="password" (keydown.enter)="login()" />
            </div>
            <div class="form-group">
                <button class="btn-core" style="width:100%;" (click)="login()">Login</button>
            </div>

            <app-notification-box #notificationBox></app-notification-box>

            <div style="display:flex; align-items: center; justify-content: center; margin:15px;">
                <div style="width: 100%; height: 1px; background-color: #ccc;"></div>
                <span style="margin: 0 10px;">or</span>
                <div style="width: 100%; height: 1px; background-color: #ccc;"></div>
            </div>

            <button class="google-btn" (click)="btnGoogleLogin_click()">
                <img
                src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg"
                width="18"
                height="18"
                />
                Continue with Google
            </button>



            <div style="padding-top:10px;">
                <!-- let's put these 2 links in a single row with adequate space between them-->
                <div class="form-group" style="display: flex; align-items: center; justify-content: space-between;">
                    <div class="form-group">
                        <!-- <a href="/forgot-password">Forgot password?</a> -->
                        <a href="" (click)="resetPassword_click(); $event.preventDefault()">Forgot password?</a>
                    </div>
                    <div class="form-group">
                      <a [href]="auditAccountSetupUrl">Sign up for Audit</a>
                  </div>
                </div>
            </div>
        </div>

        <div [hidden]="pageMode != 'require2FA'">
            <h1 style="margin-bottom:20px;">2-Factor Authentication</h1>

            <div>
                <div class="form-group">
                    <app-textbox [label]="'2-Factor Code'" [width]="'100%'" [type]="'Password'" id="2fa" name="2fa" [(ngModel)]="twoFactorCode" />
                </div>
                <div class="form-group">
                    <button class="primary" (click)="btn2FA_click()">Continue</button>
                </div>
                <div class="form-group">
                    <a href="" (click)="btnResend2FA_click(); $event.preventDefault()">Resend 2FA code</a>
                </div>
            </div>
        </div>
        
        <div [hidden]="pageMode != 'resetPassword'">
            <h1 style="margin-bottom:20px;">Forgot Password</h1>


            <div class="form-group" style="width:100%;">
                <app-textbox [label]="'Email Address'" [width]="'100%'" id="email" name="email" [(ngModel)]="email" />
            </div>
            <div class="form-group">
                <button class="primary" (click)="doResetPassword_click()">Reset Password</button>
            </div>
            <div class="form-group">
                <a href="" (click)="pageMode = 'signIn'; $event.preventDefault()">Back to sign in</a>
            </div>

        </div>

        </div>
    </div>

    <div class="promo-panel">
        <div class="promo-caption">
            <h2>{{ slides[activeIndex].title }}</h2>
            <p>{{ slides[activeIndex].description }}</p>
        </div>

        <div class="promo-stage">
            @for (slide of slides; track slide.src; let i = $index) {
                <img
                    class="promo-card"
                    [class.promo-card--front]="i === activeIndex"
                    [class.promo-card--back]="i !== activeIndex"
                    [src]="slide.src"
                    [alt]="slide.title"
                />
            }
        </div>
    </div>

</div>
